import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { setLinkedAccount, closeButtonClicked } from '../../actions/auth';

import SocialLinkedAccountPage from './SocialLinkedAccountPage';

const _mapStateToProps = (state) => ({
    socialLinkedAccountStatus:
        state.authentication.socialLinkedAccount.apiResult,
    isLoading: state.frontend.isLoading,
});
const _mapDispatchToProps = {
    handleSetLinkedAccount: setLinkedAccount,
    onCloseButtonClick: closeButtonClicked,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SocialLinkedAccountPage),
);
